module.exports = __webpack_public_path__ + "img/benjike5.fa30d025.png";